import { render, staticRenderFns } from "./buyVoicePopup.vue?vue&type=template&id=60d4ae14&scoped=true&"
import script from "./buyVoicePopup.ts?vue&type=script&lang=js&"
export * from "./buyVoicePopup.ts?vue&type=script&lang=js&"
import style0 from "./buyVoicePopup.less?vue&type=style&index=0&id=60d4ae14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d4ae14",
  null
  
)

export default component.exports